import type { DataSourceType } from 'cadenza/repository/model/data-source-type';
import type { WorkbookDataSourceDto } from 'cadenza/workbook/model/workbook-data-source-dto';
import type { DataSourceDto } from 'cadenza/api-client/dto/data-source-dto';
import type { DataSourceCapability } from 'cadenza/model/data-source-capability';

/**
 * Check if the given DataSourceType supports CMDB.
 * This is (and should be) used only during creation of the data source, where we have only the
 * selected type, otherwise the capability 'CADENZA_DB' should be checked.
 *
 * @param type - The data source type to check
 */
export function supportsCmdb (type?: DataSourceType) {
  return type === 'RDBMS';
}

/**
 * Check if a datasource has the given capability.
 *
 * @param dataSource - The data source to check
 * @param capability - The capability to check
 * @return `true` if the datasource has the given capability
 */
export function hasCapability (dataSource: WorkbookDataSourceDto | DataSourceDto, capability: DataSourceCapability): boolean {
  return dataSource?.capabilities.includes(capability);
}
